export const API_BASE_URL = 'https://api.anqingyou.top/api';

export const API_ENDPOINTS = {
  USER: {
    REGISTER: '/user/register',
    LOGIN: '/user/login',
    INFO: '/user/info',
    REFRESH_TKTOKEN: '/user/refresh-tktoken',
    SEND_VERIFICATION_CODE: '/user/send-verification-code',
    POW_CHALLENGE: '/user/pow-challenge',
    PRODUCTS: '/user/products',
    CREATE_PAYMENT: '/user/create-payment',
    CREATE_PAYMENT_ANQING: '/user/create-payment-anqing',
    CHECKIN: '/user/checkin',
    CHECKIN_MONTHLY: '/user/checkin/monthly',
  },
  // 问题相关
  QUESTION: {
    QUERY: '/question/query',
    COURSES: '/question/courses',
    COURSE_QUESTIONS: '/question/course/questions'
  },
  // 系统相关
  SYSTEM: {
    ANNOUNCEMENT: '/system/announcement'
  }
};

// 从环境变量获取公告内容
export const ANNOUNCEMENT_TEXT = process.env.VUE_APP_ANNOUNCEMENT || '';
export const ANNOUNCEMENT_TYPE = process.env.VUE_APP_ANNOUNCEMENT_TYPE || 'info'; // info, warning, success, error
export const ANNOUNCEMENT_ENABLED = process.env.VUE_APP_ANNOUNCEMENT_ENABLED === 'true';